import React from "react";
import { useTranslation } from "react-i18next";
import { Form, Select } from "antd";
import styles from "./ViewReward.module.scss";

export interface ViewRewardCategoriesTabProps {
  reward: any;
  canEdit: boolean;
  brands: any[];
  categories: any[];
  clusters: any[] | null;
  branchOffices: any[];
  onSearchBrands: (value: string) => void;
  onSearchCategories: (value: string) => void;
  onSearchBranchOffices: (value: string) => void;
  getOptions: (items: any) => React.ReactNode;
  getOptionsCategories: (items: any) => React.ReactNode;
}

const ViewRewardCategoriesTab: React.FC<ViewRewardCategoriesTabProps> = ({
  reward,
  canEdit,
  brands,
  categories,
  clusters,
  branchOffices,
  onSearchBrands,
  onSearchCategories,
  onSearchBranchOffices,
  getOptions,
  getOptionsCategories,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.sectionTitle}>{t("Common-CategoriesAndSegments")}</div>
      <div className={styles.itemWrapper}>
        <Form.Item
          className={styles.formItem}
          label={t("Common-Brands")}
          name="brandIds"
          initialValue={reward?.brands?.map((brand: any) => brand.id)}
        >
          <Select
            mode="multiple"
            allowClear
            onSearch={onSearchBrands}
            placeholder={t("Common-SearchByName")}
            filterOption={(input: string, option: any) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={!canEdit}
          >
            {getOptions(brands)}
          </Select>
        </Form.Item>
        <Form.Item
          className={styles.formItem}
          label={t("Common-Categories")}
          name="categoryIds"
          initialValue={reward?.categories?.map((cat: any) => cat.id)}
        >
          <Select
            mode="multiple"
            allowClear
            showSearch
            onSearch={onSearchCategories}
            placeholder={t("Common-SearchByName")}
            filterOption={(input: string, option: any) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: "100%" }}
            disabled={!canEdit}
          >
            {getOptionsCategories(categories)}
          </Select>
        </Form.Item>
      </div>
      <div className={styles.itemWrapper}>
        <Form.Item
          className={styles.formItem}
          label={t("Common-Clusters")}
          name="clusterIds"
          initialValue={reward?.clusters?.map((c: any) => c.id)}
        >
          <Select
            mode="multiple"
            allowClear
            placeholder={t("Common-Select")}
            filterOption={(input: string, option: any) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={!canEdit}
          >
            {(clusters || []).map((c: any) => (
              <Select.Option value={c.id} key={c.id}>
                {c.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          className={styles.formItem}
          label={t("Common-BranchOffices")}
          name="branchOfficeIds"
          initialValue={reward?.branchOffices?.map((bo: any) => bo.id)}
        >
          <Select
            mode="multiple"
            allowClear
            showSearch
            onSearch={onSearchBranchOffices}
            placeholder={t("Common-SearchByName")}
            filterOption={(input: string, option: any) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={!canEdit}
          >
            {branchOffices.map((bo: any) => (
              <Select.Option value={bo.id} key={bo.id}>
                {bo.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </>
  );
};

export default ViewRewardCategoriesTab;
